import type { OrderTakingWindow } from '@/api/types/window.types';

declare const window: OrderTakingWindow;

export const getAppConfig = () => window.salja.orders.config;
export const getAppJsonConfig = () => window.salja.orders.jsonConfig;
export const getTranslations = () => window.salja.orders.text;
export const getSentryConfig = () => window.salja.orders.sentryConfig;
export const getAppVersion = () => window.salja.orders.version;
